import React, { useEffect, useState } from "react";

const UAEPassRedirect: React.FC = () => {
  const [statusMessage, setStatusMessage] = useState(
    "Redirecting to Falektayyeb app..."
  );
  const [deepLink, setDeepLink] = useState("");
  const [showManualRedirect, setShowManualRedirect] = useState(false);

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const code = urlParams.get("code");
    const state = urlParams.get("state");
    const error = urlParams.get("error");
    const appScheme = "falektayyeb://";

    if (error) {
      setStatusMessage(`Authentication failed: ${error}`);
    } else if (code) {
      const deepLinkUrl = `${appScheme}uaepass/callback?code=${encodeURIComponent(
        code
      )}&state=${encodeURIComponent(state || "")}`;
      setDeepLink(deepLinkUrl);

      // Direct redirect
      window.location.href = deepLinkUrl;

      // Fallback via iframe
      setTimeout(() => {
        const iframe = document.createElement("iframe");
        iframe.style.display = "none";
        iframe.src = deepLinkUrl;
        document.body.appendChild(iframe);
      }, 100);

      // Show manual button
      setTimeout(() => {
        setShowManualRedirect(true);
        setStatusMessage(
          "Please click the button below if the app did not open:"
        );
      }, 2000);

      // iOS fallback
      setTimeout(() => {
        if (/iPhone|iPad|iPod/i.test(navigator.userAgent)) {
          window.location.href =
            "https://apps.apple.com/app/falektayyeb/id123456789";
        }
      }, 5000);
    } else {
      setStatusMessage("Invalid authentication response");
    }
  }, []);

  return (
    <div style={styles.body}>
      <div style={styles.container}>
        <h2>Falektayyeb - UAE Pass</h2>
        <div style={styles.loader} />
        <p>{statusMessage}</p>
        {showManualRedirect && (
          <div>
            <p>If the app doesn't open automatically:</p>
            <a href={deepLink} style={styles.button}>
              Open Falektayyeb App
            </a>
          </div>
        )}
      </div>
    </div>
  );
};

const styles: { [key: string]: React.CSSProperties } = {
  body: {
    fontFamily:
      '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "100vh",
    margin: 0,
    backgroundColor: "#f5f5f5",
  },
  container: {
    textAlign: "center",
    padding: 40,
    background: "white",
    borderRadius: 10,
    boxShadow: "0 2px 10px rgba(0,0,0,0.1)",
    maxWidth: 400,
  },
  loader: {
    border: "3px solid #f3f3f3",
    borderTop: "3px solid #007B3A",
    borderRadius: "50%",
    width: 50,
    height: 50,
    animation: "spin 1s linear infinite",
    margin: "20px auto",
  },
  button: {
    backgroundColor: "#007B3A",
    color: "white",
    padding: "12px 24px",
    textDecoration: "none",
    borderRadius: 6,
    display: "inline-block",
    marginTop: 20,
  },
};

// Add global keyframes using styled-components or CSS file if needed
export default UAEPassRedirect;
